<template>

    <div class="modal fade" id="searchDocumentModal" tabindex="-1" role="dialog" v-if="dataLoaded">
        <div class="modal-dialog modal-lg modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                    <h4 class="modal-title" v-text="lang.get('documents.fg.header')"></h4>
                </div>
                <div class="modal-body text-center" v-if="getGrids['documents']">
                    <server-table
                        :data-columns="JSON.stringify(getGrids.documents.columns)"
                        :data-url="getGrids.documents.uri"
                        :preference-url="getGrids.documents.preferenceurl"
                        :doubleClickCb="dbclckCb"
                    ></server-table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import Hub from '../../../Hub';
    import Lang from '../../../Lang';
    import ServerTable from '../../../Libraries/ServerTable/DefaultServerTable';

    export default {

        components: {
            ServerTable,
        },

        computed: {
            ...mapGetters([
                'dataLoaded',
                'getGrids',
            ])
        },

        data() {
            return {
                lang:Lang,
            }
        },

        destroyed() {
            Hub.$off('close-document-selector', this.closeSelector);
            Hub.$off('open-document-selector', this.openSelector);
        },

        methods: {

            closeSelector() {
                $('#searchDocumentModal').modal('hide');
            },

            dbclckCb(e) {
                this.closeSelector();
                this.onSelected(e);
            },

            openSelector() {
                $('#searchDocumentModal').modal('show').on("shown.bs.modal");
            },

        },

        mounted() {
            this.$nextTick(function () {
                Hub.$on('close-document-selector', this.closeSelector);
                Hub.$on('open-document-selector', this.openSelector);
            }.bind(this));
        },

        name: "DocumentSelector",

        props: {
            onSelected: Function
        },
    }

</script>
